import { useFriend } from '@/hooks/contacts/use-friends';
import useGroupInfo from '@/hooks/groups/use-group-info';
import { ConversationMessageContentType } from '@/models/conversations/conversation';
import { transformMessageTextByType } from '@/utils/transform-message-text-by-type';
import type { ContentCommonProps } from './content-common-props';

type Props = Pick<ContentCommonProps, 'message'>;

export default function ContentAnnouncement({ message }: Props) {
  const isGroup = 'GroupID' in message;
  const { canManage } = useGroupInfo(isGroup ? message.GroupID : null);
  const { friend } = useFriend(message.UserID);

  if (message.MsgType === ConversationMessageContentType.LeaveGroup && !canManage) return null;

  return (
    <div
      key={message.ID}
      className='my-3 flex w-full justify-center text-center text-sm text-neutral-950'>
      {message.MsgType === ConversationMessageContentType.Notice
        ? message.Message.split('|')[0]
        : transformMessageTextByType(message, friend?.RemarkName)}
    </div>
  );
}
